import React from 'react';
import styled from "styled-components";
import { GiftCardBalance } from '../../../../../types/gift-card';
import moment from 'moment';
import { centsToCurrencyString } from '../../../../../utils/numbers';

const Container = styled.div`
    font-size: 1.25rem;
`;

const BalanceTitle = styled.p`
    font-family: var(--ff-text);
    font-size: 1em;
    line-height: 1.2em;
    font-weight: 700;
    margin: 1.5em 0 0.75em !important;
    text-align: center;
`;

const BalanceValue = styled.p`
    font-family: var(--ff-subtitle);
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 0 !important;
    text-align: center;
`;

const BalanceDetail = styled.div`
`;

const BalanceItem = styled.p`
    margin: 0 !important;
`;

const BalanceItemValue = styled.span`
  font-family: var(--ff-subtitle);
  font-size: 1em;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 0 !important;
`;

const BalanceItemDescription = styled.span`
  font-size: 0.85em;
  line-height: 1;
  margin-bottom: 0 !important;
`;

interface Props {
    balance: GiftCardBalance;
}

const UserWalletCardBalance: React.FC<Props> = ({ balance }) => {
    const date = moment(balance.expirationDate);

    return (
        <Container>
            <BalanceTitle>Tu saldo disponible es de:</BalanceTitle>

            {balance.money !== null && <BalanceValue>{centsToCurrencyString(balance.money)}</BalanceValue>}

            {(balance.tickets !== null || balance.combos !== null) && <BalanceDetail>
                {balance.tickets !== null && (
                    <BalanceItem>
                        <BalanceItemValue>{`${balance.tickets}`}</BalanceItemValue>
                        {' '}
                        <BalanceItemDescription>Boletos</BalanceItemDescription>
                    </BalanceItem>
                )}
                {balance.combos !== null && (
                    <BalanceItem>
                        <BalanceItemValue>{`${balance.combos}`}</BalanceItemValue>
                        {' '}
                        <BalanceItemDescription>Combos</BalanceItemDescription>
                    </BalanceItem>
                )}
            </BalanceDetail>}
            
            <p className="text-center small mt-4">
                Vencimiento de saldo al {date.format('DD [de] MMMM [de] YYYY')}
            </p>
        </Container>
    );
};

export default UserWalletCardBalance;